import '../stylus/rentingpersonas.sass'

//FontAwsome
import '../libs/fontawsome/css/fontawesome-all.min.css'
import '../libs/open-sans.css'
import {addCurrency} from './include/utils.js'
import {initAll, initBuscador} from './include/global.js'

//modernizr
import '../libs/modernizr/modernizr-custom.js';

/** Dependencia de boostrap **/
import 'bootstrap/js/dist/collapse';
import 'bootstrap/js/dist/util';
import 'bootstrap/js/dist/modal';
import 'bootstrap/js/dist/dropdown';
import 'bootstrap/js/dist/carousel';
import 'bootstrap/js/dist/offcanvas';
import Tooltip from 'bootstrap/js/dist/tooltip';


var iniciar_con_scroll = false;

window.onscroll = function () { 

    if(!iniciar_con_scroll){

		import("scriptjs").then((module) => {
			const $script = module.default;
			$script("https://www.google.com/recaptcha/api.js?render=6LdxY50UAAAAAHpijDbmVg2cGb2unL7NEZ5wQnZD");
		});

	
		$('.link-detalles').on('click', function(event){
			event.preventDefault()
			event.stopPropagation()
	
			let $car_sel 	= $(this).parents('.car').first()
			,	$act_act	= $('.car.active').not($car_sel)
			,	$cars 		= $('.car').not($car_sel)
			,	$detail 	= $(this)
	
			destroyDetails(function(){
				$act_act.removeClass('active')
				$car_sel.addClass('active').removeClass('opaque')
				$cars.addClass('opaque')
				if(screen.width < 993){
					let $details 	= $car_sel.find('.details-here')
					let $carContent = $car_sel.find('.car-content').first()
					, $toHide 		= $carContent.find('.collection, .link-ft, .solicitar, .link-detalles')
					$carContent.find('.chars-hide').slideDown('fast', function(){ $(this).css('display', 'flex')})
					$toHide.slideUp('fast')
					createDetails($details, $car_sel)
				}
				else{
					let $details 	= $('.details-max')
					,	$aclose 	= $('.details-max-close')
					if($details.length == 0){	        		
						$details 	= $('<div class="details-max" />').appendTo('#paso2')
						$aclose 	= $('<a class="details-max-close" hyref="#"/>').appendTo('#paso2')
					}    	
	
					$act_act.find('.card-title').animate({opaque: 1}, 'fast')
					$act_act.find('.solicitar, .link-detalles').slideDown('fast')
					$act_act.find('.card-footer').slideUp('fast')
	
					$act_act.find('.card-title').animate({opaque: 0}, 'fast')
					$car_sel.find('.solicitar, .link-detalles').slideUp('fast')
					$car_sel.find('.card-footer').slideDown('fast')
					createDetails($details, $car_sel, {'top': ($detail.offset().top + $detail.outerHeight()), 'left': 0}, $car_sel)
	
					$aclose.on('click', function(event){
						event.preventDefault()
						event.stopPropagation()
						closeDetails($car_sel)
					})
				}	        
			})
	
	
		})
	
		$('.chars-hide').on('click', function(event){
			event.preventDefault()
			event.stopPropagation()
			destroyDetails()
		});

		const tooltipTriggerList = document.querySelectorAll('[data-bs-toggle="tooltip"]');
		const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new Tooltip(tooltipTriggerEl));
		
	
        iniciar_con_scroll = true;
    } 
 };

$(document).ready(function(){
	

    initAll()
	initBuscador()	

	/*
	var secciones = $('.seccion');
    secciones.slice(2).hide();

    $(window).one('scroll', function() {
        secciones.slideDown();
    }); */

	$('[data-bs-toggle="collapse"]').on('click', function() {
		// Obtener el valor actual de background-image
		var currentBackground = $('.desplegable').css('background-image');
		// Verificar si el fondo actual coincide con la URL deseada

		if (currentBackground == 'none') {
			$('.desplegable').css('background-image', 'url(/public/img/banner-planes.jpg)');
		} else {
			$('.desplegable').css('background-image', 'none');
		}
    });

	$('.plan').click(function(){
        var button = $('[data-bs-toggle="collapse"]');
        button.click();
    });

	$('.subtitle').click(function() {
		var icono = $('.icono');
		if (icono.hasClass('alk-angle-down')) {
			icono.removeClass('alk-angle-down').addClass('alk-angle-up');
		} else {
			icono.removeClass('alk-angle-up').addClass('alk-angle-down');
		}
	});
})

function createDetails($details, $esto, offset = {}, $car_sel = $()){
	let isMovil = screen.width < 993
	let tableChecks1 = 	`<table>
				        	<tbody>
					          	<tr>
									<td><i class="fa fa-check green-color"></i><span>${x_textos['RNT2043-0']}</span></td>
									<td><i class="fa fa-check green-color"></i><span>${x_textos['RNT2043-1']}</span></td>
					          	</tr>
					          	<tr>
									<td><i class="fa fa-check green-color"></i><span>${x_textos['RNT2044-0']}</span></td>
									<td><i class="fa fa-check green-color"></i><span>${x_textos['RNT2044-1']}</span></td>
					          	</tr>
				        	</tbody>
				    	</table>`
	let tableChecks2 = 	`<ul class="custom-list">
				        	<li><i class="fa fa-check green-color"></i><span>${x_textos['RNT2045-0']}</span></li>
							<li><i class="fa fa-check green-color"></i><span>${x_textos['RNT2045-1']}</span></li>					          
							<li><i class="fa fa-check green-color"></i><span>${x_textos['RNT2046-0']}</span></li>
							<li><i class="fa fa-check green-color"></i><span>${x_textos['RNT2046-1']}</span></li>
				    	</ul>`

	let frases1 	= `<div class="fila gd"><span ${isMovil ? '' : 'class="truncate"'}>${x_textos['RNT2047-0']}</span> <strong><i class="fa fa-angle-right"></i> ` + addCurrency(1, '$', $esto.attr('data-valor_dia'), 0, true) + `</strong></div>
					    <div class="fila rp"><span ${isMovil ? '' : 'class="truncate"'}>${x_textos['RNT2047-1']}</span> <strong><i class="fa fa-angle-right"></i> ` + addCurrency(1, '$', $esto.attr('data-valor_total'), 0, true) + `</strong></div>
					    <div class="fila ahorro strong"><i class="fa fa-star"></i> ${x_textos['RNT2048-0']} <br />` + addCurrency(1, '$', $esto.attr('data-ahorro_renting'), 0, true) + `</div>`
	let frases2 	= `<div class="content-frases">
							<span class="vs strong ${isMovil ? '' : 'truncate'}">${x_textos['RNT2048-1']}</span>
							<div class="sub-title">${x_textos['RNT2049-0']}</div>
					    	<ul class="collection detalles-trad">
					    		<li class="collection-item"><span class="text">${x_textos['RNT2049-1']}</span> <span class="strong text-number red-color">` + addCurrency(1, '$', $esto.attr('data-gasto_diario'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text">${x_textos['RNT2050-0']}</span> <span class="strong text-number red-color">` + addCurrency(1, '$', $esto.attr('data-gasto_36_meses'), 0, true) + `</span></li>
					    		

					    		<li class="collection-item"><span class="single-title">${x_textos['RNT2050-1']}</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2051-0']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_cuotas'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2051-1']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_seguro'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2052-0']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_mmtoll'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2052-1']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_matricula'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2053-0']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_impuesto'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2053-1']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_soat'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2054-0']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_poliza'), 0, true) + `</span></li>
					    		
					    		<li class="collection-item"><span class="text dark strong">${x_textos['RNT2054-1']}</span> <span class="strong text-number red-color">` + addCurrency(1, '$', $esto.attr('data-trat_total'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2055-0']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_venta'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2055-1']}</span> <span class="strong text-number">` + addCurrency(1, '$', $esto.attr('data-trad_gasto_venta'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark">${x_textos['RNT2056-0']}</span> <span class="strong text-number red-color">` + addCurrency(1, '$', $esto.attr('data-trad_comic_venta'), 0, true) + `</span></li>
					    		<li class="collection-item"><span class="text dark strong">${x_textos['RNT2074-1']}</span> <span class="strong text-number red-color">` + addCurrency(1, '$', $esto.attr('data-gasto_36_meses'), 0, true) + `</span></li>

					    	</ul>
					    </div>`
	


	let val_dia 	= `<span class="price" data-price="dia"><span class="strong">` + addCurrency(1, '$', $esto.attr('data-valor_dia'), 0, true) + `</span>/${x_textos['RNT2007-0']}</span>`
	let val_mes 	= `<span class="price" data-price="mes"><span class="strong">` + addCurrency(1, '$', $esto.attr('data-valor_mes'), 0, true) + `</span>/${x_textos['RNT2004-1']}</span>`
	let iva 		= `<span class="tax">${x_textos['RNT2015-0']}</span>`
	let solicitar 	= `<a href="#solicitar-action" class="waves-effect waves-light btn alk-btn modal-trigger akgreen strong"  data-ahorro_renting = "`+ $esto.attr('data-ahorro_renting') + `" data-id_hist = "`+ $esto.attr('data-id_hist') + `" data-valor_mes = "`+ $esto.attr('data-valor_mes') + `">${x_textos['RNT2008-1']}</a>`
	if(!isMovil){
		let details_content = 
			`<div class="container">
				<div class="inset">
					<a href="#" rel="nofollow" class="cerrar-button">${x_textos['RNT2057-0']} <i class="fa fa-times"></i></a>
					<div class="row all_cont" style="margin-bottom:0">
						<div class="col c1 m4 l3 padding-max">
							<div class="max-title strong truncate">${x_textos['RNT2058-0']}</div>
							<div class="sub-title">${x_textos['RNT2058-1']}</div>
							${tableChecks2}
							<div class="center-align sub-title margin-top"><img src="${PIC_RNT + '/ic_carro_renting.png'}" alt="${x_textos['RNT2076-1']}" /> ${x_textos['RNT2076-1']}</div>
							<div class="center-align strong total-price">${addCurrency(1, '$', $esto.attr('data-valor_carro'), 0, true)}</div>
						</div>
						<div class="col c2 m4 l4 padding-min">
							<div class="max-title strong truncate">${x_textos['RNT2060-0']}</div>
							<div class="filas-content max">${frases1}</div>
							<div class="sub-title margin-top">${x_textos['RNT2060-1']}</div>
							<p class="fixed-terms ">${x_textos['RNT2057-1']}</p>

							<div class="price-buttons">
								<div class="just-price">
									${val_mes}
									${iva}
								</div>
								<div class="pre-button">								
									${solicitar}
								</div>
							</div>
						</div>
						<div class="col c3 m4 l5 white">
							${frases2}
						</div>
					</div>
					<a href="#" rel="nofollow" class="requisitos" data-content="${$esto.attr('data-condiciones')}">${x_textos['RNT2061-0']} <i class="fa fa-angle-down"></i></a>
					<div class="requisitos-content">
						<a href="#" rel="nofollow" class="cerrar-requisitos">${x_textos['RNT2057-0']} <i class="fa fa-times"></i></a>
						<div class="_container"></div>
					</div>
				</div>
			</div>`

		$details.html(details_content).offset(offset).animate({'opacity': 1}, 'fast')

		let maxHeigh = $details.find('.all_cont').height()
		$details.find('.c1').css('height', maxHeigh)
		$details.find('.c2').css('height', maxHeigh)
		$details.find('.c3').css('height', maxHeigh)


		$('.cerrar-button').on('click', function(event){
	    	event.preventDefault()
	        event.stopPropagation()
	        closeDetails($car_sel)
	    })

		$('.requisitos').on('click', function(event){
	    	event.preventDefault()
	        event.stopPropagation()
	        let $esto 		= $(this)
	        ,	$bcontent	= $esto.next('.requisitos-content')
	        ,	$content 	= $bcontent.find('._container')
	        $content.slideDown('fast', function(){
	        	$content.find('i').removeClass('fa-angle-down').addClass('fa-angle-up')
	        })

	        if($content.attr('data-cargado') != 'true'){
	        	 $.ajax({
	                        url: $esto.attr('data-content')
	                    ,   method:'GET'
	                    ,	beforeSend: function(){
	                    	$esto.html(x_textos['RNT2075-1'] + '...')
	                    }
	                    ,   success: function(data){
	                            let _data 	= JSON.parse(data)
	                            $content.html(
	                            	`<div class="row">
	                            		<div class="col s12 m4">
	                            			<div class="max-title strong truncate">${x_textos['RNT2075-0']}</div>
	                            			${_data.col1}
	                            		</div>
	                            		<div class="col s12 m4">
	                            			<div class="max-title strong truncate">${x_textos['RNT2076-0']}</div>
	                            			${_data.col2}
	                            		</div>
	                            		<div class="col s12 m4">
	                            			<div class="max-title strong truncate">${x_textos['RNT2077-0']}</div>
	                            			${_data.col3}
	                            		</div>
	                            	</div>
	                            	<div class="row">
	                            		<div class="col s12 terms">
	                            			<div class="max-title strong truncate">${x_textos['RNT2030-1']}</div>
	                            			${_data.terms}
	                            		</div>
	                            	</div>`)
	                            $bcontent.slideDown('fast')
	                            $esto.fadeOut('fast')
	                        }

	                })
	        }  
	        else{
	        	$bcontent.slideDown('fast')
	        	$esto.fadeOut('fast')
	        }
	    })
		$('.cerrar-requisitos').on('click', function(event){
	    	event.preventDefault()
	        event.stopPropagation()
	        $('.requisitos-content').slideUp('fast', function(){
	        	$('.requisitos i').removeClass('fa-angle-up').addClass('fa-angle-down')
	        	$('.requisitos').html(x_textos['RNT2061-0'] + ' <i class="fa fa-angle-down"></i>').fadeIn('fast')
	        })
	    })

	}
	else{
		let details_content = 
			`<div class="title strong">${x_textos['RNT2061-1']}</div>
			${tableChecks1}
			<div class="filas-precio-total">
				<div class="center-align sub-title"><img src="${PIC_RNT + '/ic_carro_renting.png'}" alt="${x_textos['RNT2076-1']}" /> ${x_textos['RNT2076-1']}</div>
				<div class="center-align strong total-price">${addCurrency(1, '$', $esto.attr('data-valor_carro'), 0, true)}</div>
			</div>
		    <div class="filas-content">${frases1}</div>
		    <ul class="collapsible details" data-collapsible="expandable">
			    <li data-id="1">		      	
			      	<div class="collapsible-header"><span>${x_textos['RNT2032-0']} <strong>${x_textos['RNT2048-1']}</strong> ${x_textos['RNT2049-0']}</span> <i class="material-icons">expand_more</i></div>
			      	<div class="collapsible-body">
			      		<div class="filas-content-in">${frases1}</div>
					    ${frases2}
					</div>		      	
			    </li>
			    <li data-id="2">
			    	<div class="collapsible-header"><span>${x_textos['RNT2062-0']}</span> <i class="material-icons">expand_more</i></div>
			      	<div class="collapsible-body">
				    	<p class="fixed-terms">${x_textos['RNT2062-1']}</p>
					</div>
				</li>
			</ul>
			<div class="card-action">
				<div>
	  				${val_dia}
					${val_mes}
					<span class="tax">${x_textos['RNT2015-0']}</span>
				</div>
				<a href="#solicitar-action" class="waves-effect waves-light btn alk-btn akgreen strong modal-trigger">${x_textos['RNT2008-1']}</a>
			</span>`
		$details.html(details_content).slideDown('fast')
		$('.collapsible.details').collapsible({
			onOpenEnd: function(el) { 
				let id 			= $(el).attr('data-id')
				,	$details 	= $(el).parents('.details-here')
				,	$header 	= $(el).find('.collapsible-header').first()
				if(id === '1'){
					$details.find('.filas-content').slideUp('fast', function(){
						$header.goTo()
					})
				}
				else{
					$header.goTo()
				}
				$header.find('i').text('expand_less')
				$header.addClass('active')
			}, 		
		    onCloseEnd: function(el) { 
		    	let id 			= $(el).attr('data-id')
				,	$details 	= $(el).parents('.details-here')
				,	$header 	= $(el).find('.collapsible-header').first()
				if(id === '1'){
					$details.find('.filas-content').slideDown('fast', function(){
						$header.parents('.car-content').goTo()
					})
				}
				else{
					$header.parents('.car-content').goTo()
				}
				$header.find('i').text('expand_more')
				$header.removeClass('active')
		    }
		})
	}
}

function closeDetails($car_sel){
	destroyDetails(function(){
    	$car_sel.find('.card-title, .solicitar, .link-detalles').slideDown('fast')
    	$car_sel.find('.card-footer').slideUp('fast')

    	$('.details-max').animate({'opacity': 0}, 'fast',function(){
    		$(this).remove()	      		
    	})

    	$('.details-max-close').animate({'opacity': 0}, 'fast',function(){
    		$(this).remove()	      		
    	})
    });
}


function destroyDetails(calllback){
	let $act_act	= $('.car.active')
    ,	$cars 		= $('.car.opaque')
    ,	$details 	= $act_act.find('.details-here')

    $act_act.removeClass('active')
    $cars.removeClass('opaque')

    if(screen.width >= 993){
    	if(typeof calllback == 'function') calllback()
    }
    else{
    	let $carContent = $act_act.find('.car-content').first()
    	, $toShow 		= $carContent.find('.collection, .link-ft, .solicitar, .link-detalles')
    	, $hideBtn 		= $carContent.find('.chars-hide')
    	$hideBtn.slideUp('fast')

    	$toShow.slideDown('fast', function(){
    		//$hideBtn.parents('.car').find('.car-content').goTo()
    	})

    	if($details.length != 0){
	    	$details.slideUp('fast', function(){
	    		$('.collapsible.details').collapsible('destroy');
	    		$(this).empty()
	    		//$hideBtn.parents('.car').goTo()
	    		if(typeof calllback == 'function') calllback()
	    	})
	    }
	    else{
	    	if(typeof calllback == 'function') calllback()
	    }
    }
}

